export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';

export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
export const CLEAR_ORDER_DETAIL = 'CLEAR_ORDER_DETAIL';
